<template>
  <div class="form-group m-0">
    <div id="pass-info" class="clearfix m-0 p-0">{{ $t(passwordsInfoText) }}</div>
  </div>
</template>
<script>
export default {
  props: {
    password: {
      type: String,
      default: '',
    },
    password_confirmation: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: null,
    },
    surname: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      passwordsInfoText: '',
      allRulesPassed: false,
      isPassed: false,
    };
  },
  created() {
    this.lastChange = '';
    this.classText = '';
  },
  mounted() {
    this.passwordsInfo = $('#pass-info');
  },
  methods: {
    validatePassword() {
      const rules = {
        length: /(?=.{6,}).*/,
        upperCase: /(?=.*[A-Z])/,
        lowerCase: /(?=.*[a-z])/,
        digit: /(?=.*\d)/,
        symbol: /(?=.*[!@#$%^&*(),.?:{}|<>+])/,
        noNameSurname: new RegExp(`^(?!.*(${this.name}|${this.surname})).*$`, 'iu'),
      };

      const password = this.password;

      this.classText = 'stillweakpass';
      if (!rules.length.test(password)) {
        this.passwordsInfoText = 'Şifre Mesajları.Kısa';
      } else if (!rules.upperCase.test(password)) {
        this.passwordsInfoText = 'Şifre Mesajları.Büyük Harf';
      } else if (!rules.lowerCase.test(password)) {
        this.passwordsInfoText = 'Şifre Mesajları.Küçük Harf';
      } else if (!rules.digit.test(password)) {
        this.passwordsInfoText = 'Şifre Mesajları.Rakam';
      } else if (!rules.symbol.test(password)) {
        this.passwordsInfoText = 'Şifre Mesajları.Özel Karakter';
      } else if (this.containsSequentialNumbers(password)) {
        this.passwordsInfoText = 'Şifre Mesajları.Ardışık';
      } else if (!rules.noNameSurname.test(password)) {
        this.passwordsInfoText = 'Şifre Mesajları.İsim Soyisim';
      } else if (this.password !== this.password_confirmation) {
        this.passwordsInfoText = 'Şifre Mesajları.Eşleşmedi';
      } else {
        this.passwordsInfoText = 'Şifre Mesajları.Eşleşti';
        this.classText = 'vrystrongpass';
        this.allRulesPassed = true;
        this.isPassed = true;
      }

      this.changeClass(this.classText);
    },
    containsSequentialNumbers(password) {
      const digits = '0123456789';
      const reverseDigits = '9876543210';

      for (let i = 0; i < digits.length - 2; i++) {
        const forwardSequence = digits.substring(i, i + 3);
        const backwardSequence = reverseDigits.substring(i, i + 3);

        if (password.includes(forwardSequence) || password.includes(backwardSequence)) {
          return true;
        }
      }

      return false;
    },
    changeClass(value) {
      if (this.lastChange !== this.classText) {
        this.passwordsInfo.attr('class', 'clearfix');
        this.passwordsInfo.addClass(value);
        this.lastChange = this.classText;
      }
    },
  },
  watch: {
    password(val) {
      this.validatePassword();
    },
    password_confirmation(val) {
      this.validatePassword();
    },
  },
};
</script>
